import React, { ReactElement, useRef } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { StudyObjectGroupCompareEnum } from '../configs/StudiesObjectsCompareGroupTypesConfig'

const ButtonStyle = styled.button<{ active: boolean; isLarge?: boolean }>`
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: ${({ isLarge }) => (isLarge ? 'row' : 'column')};
  align-items: center;
  justify-content: ${({ isLarge }) => (isLarge ? 'center' : 'space-between')};
  gap: ${({ isLarge }) => (isLarge ? '12px' : '0')};
  width: ${({ isLarge }) => (isLarge ? '100%' : 'auto')};
  height: ${({ isLarge }) => (isLarge ? '80px' : '144px')};
  flex: ${({ isLarge }) => (isLarge ? 'initial' : '1 1 0%')};
  min-width: 160px;

  @media (max-height: 800px) {
    height: ${({ isLarge }) => (isLarge ? '70px' : '130px')};
  }

  ${({ active }) =>
    active
      ? `
    color: white;
    background-color: #252525;
  `
      : `
    color: #252525;
    background-color: #f7f7f7;
  `}
`

const LabelStyle = styled.p<{ isLarge?: boolean }>`
  overflow: hidden;
  text-align: ${({ isLarge }) => (isLarge ? 'left' : 'center')};
  text-overflow: ellipsis;
  font-family: Fira Sans, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  min-height: ${({ isLarge }) => (isLarge ? '0' : '30px')};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`

const InputSelectionButton = ({
  active = false,
  labelKey,
  icon,
  handleOnClickInputSelectionButton,
  isUsersList = false,
  onFileSelected,
  isLarge = false,
}: {
  active?: boolean
  labelKey: string
  icon: ReactElement
  handleOnClickInputSelectionButton: () => void
  isUsersList?: boolean
  onFileSelected?: (file: File) => void
  isLarge?: boolean
}) => {
  const { t } = useTranslation()
  const fileInputRef = useRef<HTMLInputElement>(null)

  const onClickButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    if (isUsersList) {
      fileInputRef.current?.click()
    } else {
      handleOnClickInputSelectionButton()
    }
  }

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      handleOnClickInputSelectionButton()
      onFileSelected && onFileSelected(file)
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  return (
    <>
      <ButtonStyle
        active={active}
        isLarge={isLarge}
        type="button"
        onClick={onClickButton}
      >
        {icon}
        <LabelStyle isLarge={isLarge}>{t(labelKey)}</LabelStyle>
      </ButtonStyle>
      {isUsersList && (
        <input
          type="file"
          accept=".csv"
          ref={fileInputRef}
          onChange={onFileChange}
          style={{ display: 'none' }}
        />
      )}
    </>
  )
}

export default InputSelectionButton
